import cloudinaryRuntime_36L4T9sJNZhmYmcxoi_45jVlauEbzSPQfb_0jiPjiLcuk6c from '/app/node_modules/@nuxt/image/dist/runtime/providers/cloudinary'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536,"xs":320,"xxl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"cloudinary"} */
  provider: "cloudinary",
  providers: {
      ['cloudinary']: { setup: cloudinaryRuntime_36L4T9sJNZhmYmcxoi_45jVlauEbzSPQfb_0jiPjiLcuk6c, defaults: {"baseURL":"https://res.cloudinary.com/dzhhy3ovo/image/upload","modifiers":{"format":"auto","quality":"50","fit":"cropping"}} }
  }
}
